var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"kiosk",rawName:"v-kiosk"}],staticClass:"quick-book-item",on:{"click":_vm.clicAdd}},[_c('span',[_vm._v("+")])])}
var staticRenderFns = []

export { render, staticRenderFns }